import React, { useEffect, useState } from "react";
import "../capacityListingNew/capacityListingNew.css";
import { Tabs, Tab, Row, Col, Nav, Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment";
import biddingGeneratorService from "../../../components/Services/biddingGenerator.service";
import biddingConsumerService from "../../../components/Services/biddingConsumer.service";
import capacityGeneratorService from "../../../components/Services/capacityGenerator.service";
import capacityConsumerService from "../../../components/Services/capacityConsumer.service";
import CapacityListingHeader from "./capacityListingHeader";
import ApproveBidsModal from "../../DashBoard/approveBidsModal";
import NodataFound from "../../../commons/Toast/noDataFound";
import bankingService from "../../../components/Services/banking.service";

import Accordion2 from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Styles from "../../../Styles/Banking/bankingList.module.css";
import BankingList from "./BankingList";
import ReceivedBankingRequests from "../../Auth/Banking/receivedBankingRequests";

const CapacityListingNew = () => {
  const [key, setKey] = useState("Closed");
  console.debug("CapacityListingNew rendered", key);
  const [receivedBidsList, setReceivedBidsList] = useState(null);
  const [isApproveBidsModal, setApproveBidsModal] = useState(false);
  const [capacityList, setCapacityList] = useState(null);
  const [comparedBids, setComparedBids] = useState(null);
  const [jsonData, setJsonData] = useState([]);
  const [placedBidsList, setPlacedBidsList] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [bankingRequest, setBankingRequest] = useState([]);
  const [bankingReceived, setBankingReceived] = useState([]);
  const [activeBankId, setActiveBankId] = useState("");
  const [activeState, setActiveState] = useState("RECEIVED");
  const [isReceivedBankModal, setIsReceivedBankModal] = useState(false);

  const [closedList, setClosedList] = useState([]);
  const [openList, setOpenList] = useState([]);
  const [withdrawnList, setWithdrawnList] = useState([]);

  const openReceivedBankModal = (item) => {
    console.debug(isReceivedBankModal);
    setIsReceivedBankModal(item);
  };
  const closeReceivedBankModal = () => {
    setIsReceivedBankModal(false);
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);

    handleFetchAllData(panel);
  };

  const role = useSelector((state) => state?.sessionState?.role);
  const configKey = useSelector((state) => state?.sessionState?.connectionName);

  const selectedCapacityId = localStorage.getItem("selectedItemId");

  const handleSelect = (key) => {
    setKey(key);
  };

  const handleFetchAllData = (id) => {
    setActiveBankId(id);
    fetchViewReceived(id);
    // fetchViewPlaced(id);
  };

  const fetchViewReceived = async (id) => {
    bankingService
      .getReceivedBankingRequests(id || activeBankId)
      .then((res) => {
        console.debug(res?.data?.data);
        setBankingRequest(res?.data?.data);
      })
      .catch((err) => console.log(err));
  };

  const fetchViewPlaced = async (id) => {
    bankingService
      .placeBankingConnectionRequest(id)
      .then((res) => {
        console.debug(res?.data?.data);
        setBankingRequest(res?.data?.data);
      })
      .catch((err) => console.log(err));
  };

  const updateCapacityData = (data) => {
    if (key === "Closed") {
      setClosedList(data);
    } else if (key === "Withdrawn") {
      setWithdrawnList(data);
    } else if (key === "Expired") {
      setOpenList(data);
    }
  };

  const getCapacityListing = (eventKey) => {
    setOpenList([]);
    setWithdrawnList([]);
    setClosedList([]);
    const currentDateTime = moment(new Date()).format("DD-MMM-YYYY HH:mm");
    const reqBody = {
      search: [
        {
          operation: eventKey === "Expired" ? "LESS_THAN_EQUAL" : "LIKE",
          key:
            eventKey === "Expired"
              ? role === "BANKING"
                ? "expiryAt"
                : "bidEndAt"
              : "status",
          value:
            eventKey === "Expired" ? currentDateTime : eventKey?.toUpperCase(),
        },
      ],
    };
    if (role === "GENERATOR") {
      capacityGeneratorService
        .getAllGeneratorCapacity(reqBody)
        .then((response) => {
          if (response && response.data.code === 200) {
            updateCapacityData(response?.data?.data);
          }
        })
        .catch((err) => console.log(err));
    } else if (role === "CONSUMER") {
      capacityConsumerService
        .getAllConsumerCapacity(reqBody)
        .then((response) => {
          if (response && response.data.code === 200) {
            updateCapacityData(response?.data?.data);
          }
        })
        .catch((err) => console.log(err));
    } else if (role === "BANKING") {
      bankingService
        .getAllMyBankingListing(reqBody)
        .then((response) => {
          if (response && response.data.code === 200) {
            updateCapacityData(response?.data?.data);
          }
        })
        .catch((err) => console.log(err));
    }
  };
  useEffect(() => {
    getCapacityListing(key);
  }, [key]);

  const closeApproveBidsModal = () => {
    setApproveBidsModal(false);
  };
  const getComparedBidDetails = (data, bidId) => {
    if (role === "GENERATOR") {
      biddingGeneratorService
        .getReceivedBidsListByGenCapacityId(data?.id, bidId)
        .then((response) => {
          if (response?.data?.code === 200) {
            setComparedBids(response?.data?.data);
          }
        })
        .catch((error) => {
          console.error("Api call error:", error);
        });
    } else if (role === "CONSUMER")
      biddingConsumerService
        .getReceivedBidsListByConCapacityId(data?.id, bidId)
        .then((response) => {
          if (response?.data?.code === 200) {
            setComparedBids(response?.data?.data);
          }
        })
        .catch((error) => {
          console.error("Api call error:", error);
        });
  };

  const getPlacedBidDetails = (id) => {
    setPlacedBidsList(null);
    if (role === "GENERATOR") {
      biddingGeneratorService
        .getPlacedBidsGenerator(id)
        .then((response) => {
          if (response?.data?.code === 200) {
            setPlacedBidsList(response?.data?.data);
          }
        })
        .catch((error) => {
          console.error("Api call error:", error);
        });
    } else if (role === "CONSUMER")
      biddingConsumerService
        .getPlacedBidsConsumer(id)
        .then((response) => {
          if (response?.data?.code === 200) {
            setPlacedBidsList(response?.data?.data);
          }
        })
        .catch((error) => {
          console.error("Api call error:", error);
        });
  };
  const handleApproveBids = (data, item) => {
    setApproveBidsModal(true);
    setJsonData(item);
    getComparedBidDetails(data, item?.id);
  };
  const getReceivedBidsGenerator = (data) => {
    setReceivedBidsList(null);
    biddingGeneratorService
      .getReceivedBidsGenerator(data?.id, true)
      .then((response) => {
        if (response?.data?.code === 200) {
          setReceivedBidsList(response?.data?.data);
        }
      });
  };

  const getReceivedBidsConsumer = (data) => {
    setReceivedBidsList(null);
    biddingConsumerService
      .getReceivedBidsConsumer(data?.id, true)
      .then((response) => {
        if (response?.data?.code === 200) {
          setReceivedBidsList(response?.data?.data);
        }
      });
  };
  const handleViewConnection = (data, item) => {
    setComparedBids(null);
    if (role === "GENERATOR") {
      const conCapId = item?.capacityConsumerId;
      const genCapId = data?.id;
      biddingGeneratorService
        .getConnectionDetails(conCapId, genCapId)
        .then((response) => {
          if (response?.data?.code === 200) {
            setApproveBidsModal(true);
            setComparedBids(response?.data?.data);
          }
        })
        .catch((err) => console.log(err));
    } else if (role === "CONSUMER") {
      const conCapId = data?.id;
      const genCapId = item?.capacityGeneratorId;
      biddingConsumerService
        .getConnectionDetails(conCapId, genCapId)
        .then((response) => {
          if (response?.data?.code === 200) {
            setApproveBidsModal(true);
            setComparedBids(response?.data?.data);
          }
        })
        .catch((err) => console.log(err));
    }
  };
  const [activeTab, setActiveTab] = useState("first");

  const handleAccordionItemClick = (tabKey) => {
    setActiveTab(tabKey); // Update the active tab when an accordion header is clicked
  };
  return (
    <>
      {isReceivedBankModal && (
        <ReceivedBankingRequests
          isOpen={isReceivedBankModal}
          closeReceivedBankModal={closeReceivedBankModal}
          getReceivedConnectionsBanknig={fetchViewReceived}
        />
      )}
      {isApproveBidsModal && (
        <ApproveBidsModal
          isOpen={isApproveBidsModal}
          comparedBids={comparedBids}
          jsonData={jsonData}
          closeApproveBidsModal={closeApproveBidsModal}
          getReceivedBidsConsumer={getReceivedBidsConsumer}
          getReceivedBidsGenerator={getReceivedBidsGenerator}
        />
      )}
      <div className="">
        <div className="card-box p-4" id="capacityListingNew">
          <Tabs
            variant="underline"
            defaultActiveKey={"Closed"}
            id="Closed"
            onSelect={(e) => handleSelect(e)}
          >
            <Tab eventKey={"Closed"} title="Closed" className="table-scrollY">
              <Tab.Container
                id="left-side-tabs"
                defaultActiveKey="first"
                activeKey={activeTab}
              >
                {role === "BANKING" ? (
                  closedList?.length > 0 ? (
                    closedList?.map((item, i) => (
                      <Accordion2
                        expanded={expanded === item?.id}
                        onChange={handleChange(item?.id)}
                        sx={{
                          background: "white",
                          borderRadius: "8px",
                          border: "1px solid #cccccc",
                          marginBottom: "16px",
                          backgroundColor: "#fff3e8",
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon style={{ fontSize: "32px" }} />
                          }
                          aria-controls="panel2bh-content"
                          id="panel2bh-header"
                        >
                          <div className={Styles.accMainContainer}>
                            <div className={Styles.mainContent}>
                              {item?.name}
                            </div>
                            <div className={Styles.listingDetailsCont}>
                              <div className={Styles.eachListSection}>
                                <div>Quantity(MW):</div>
                                <div>{item?.requiredQty}</div>
                              </div>
                              <div className={Styles.eachListSection}>
                                <div>Banking Factor:</div>
                                <div>{item?.bankingFactor}</div>
                              </div>
                              <div className={Styles.eachListSection}>
                                <div>Settlement Rate:</div>
                                <div>{item?.settlementRate}</div>
                              </div>
                              <div className={Styles.eachListSection}>
                                <div>Minimum Slot:</div>
                                <div>{item?.minimumSlots}</div>
                              </div>
                              <div className={Styles.eachListSection}>
                                <div>Expiry Date:</div>
                                <div>{item?.expiryAt}</div>
                              </div>
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className={Styles.bankingMainContainer}>
                            <div className={Styles.bankDetailsSec}>
                              <div className={Styles.bankListCont}>
                                <div className={Styles.mainContent}>
                                  Injection:
                                </div>
                                {item?.bankingSlotInjects?.map((ele) => (
                                  <div className={Styles.bankListDetails}>
                                    {ele?.dateStartAt}/{ele?.dateEndAt}-
                                    {ele?.slotStartAt}/{ele?.slotEndAt}
                                  </div>
                                ))}
                              </div>
                              <div className={Styles.bankListCont}>
                                <div className={Styles.mainContent}>Drawl:</div>
                                {item?.bankingSlotDrawls?.map((ele) => (
                                  <div className={Styles.bankListDetails}>
                                    {ele?.dateStartAt}/{ele?.dateEndAt}-
                                    {ele?.slotStartAt}/{ele?.slotEndAt}
                                  </div>
                                ))}
                              </div>
                            </div>
                            <div className={Styles.detailsSections}>
                              <div className={Styles.selectionSections}>
                                <div
                                  className={
                                    activeState === "PLACED" &&
                                    Styles.activeState
                                  }
                                >
                                  PLACED
                                </div>
                                <div
                                  className={
                                    activeState === "RECEIVED" &&
                                    Styles.activeState
                                  }
                                >
                                  RECEIVED
                                </div>
                              </div>
                              <div className={Styles.displaySection}>
                                <table>
                                  <tr className={Styles.tableMainCont}>
                                    <th>Company Name</th>
                                    <th>Quantity</th>
                                    <th>Banking Factor</th>
                                    <th>Settlement Rate</th>
                                    <th>Status</th>
                                    <th>View</th>
                                  </tr>
                                  {bankingRequest?.map((ele) => (
                                    <tr className={Styles.tableDetails}>
                                      <th
                                        className={
                                          !(
                                            ele?.status === "CLOSED" ||
                                            ele?.status === "ACCEPTED"
                                          ) && "company-name-blur"
                                        }
                                      >
                                        {console.debug(
                                          ele?.status !== "CLOSED"
                                        )}
                                        {
                                          ele?.againstBankingListing?.company
                                            ?.companyName
                                        }
                                      </th>
                                      <th>
                                        {
                                          ele?.againstBankingListing
                                            ?.requiredQty
                                        }
                                      </th>
                                      <th>
                                        {
                                          ele?.againstBankingListing
                                            ?.bankingFactor
                                        }
                                      </th>
                                      <th>
                                        {
                                          ele?.againstBankingListing
                                            ?.settlementRate
                                        }
                                      </th>
                                      <th>{ele?.status}</th>
                                      <th>
                                        <div
                                          onClick={() =>
                                            openReceivedBankModal(ele)
                                          }
                                        >
                                          <img
                                            src="images/view-icon.png"
                                            alt="View"
                                          />
                                        </div>
                                      </th>
                                    </tr>
                                  ))}
                                </table>
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion2>
                    ))
                  ) : (
                    <NodataFound />
                  )
                ) : (
                  <Accordion defaultActiveKey="0">
                    {closedList?.length > 0 ? (
                      closedList?.map((data, i) => (
                        <Accordion.Item key={i} eventKey={i}>
                          <Accordion.Header>
                            <CapacityListingHeader item={data} />
                          </Accordion.Header>
                          <Accordion.Body
                            onEntering={() => {
                              handleAccordionItemClick("first");
                              getPlacedBidDetails(data?.id);
                            }}
                          >
                            <Row className=" g-0">
                              <Col sm={2} className="left-side">
                                <Nav variant="nav" className="flex-column">
                                  <Nav.Item
                                    onClick={() => {
                                      handleAccordionItemClick("first");
                                      getPlacedBidDetails(data?.id);
                                    }}
                                  >
                                    <Nav.Link eventKey="first">Placed</Nav.Link>
                                  </Nav.Item>
                                  <Nav.Item
                                    onClick={() => {
                                      role === "CONSUMER"
                                        ? getReceivedBidsConsumer(data)
                                        : getReceivedBidsGenerator(data);
                                      handleAccordionItemClick("second");
                                    }}
                                  >
                                    <Nav.Link eventKey="second">
                                      Received
                                    </Nav.Link>
                                  </Nav.Item>
                                </Nav>
                              </Col>
                              <Col sm={10} id="right-side">
                                <Tab.Content>
                                  <Tab.Pane eventKey="first">
                                    <div className=" table-responsive doc-cus-table">
                                      {placedBidsList &&
                                      placedBidsList?.length > 0 ? (
                                        <table className="cus-table table-bordered my-documents-table">
                                          <thead className="table-header">
                                            <tr>
                                              <th>S. No.</th>
                                              <th>Company Name</th>
                                              <th>
                                                {"Energy Rate (₹ per Unit)"}
                                              </th>
                                              {/* <th>{role === 'GENERATOR' ? 'Consumer Landed Cost (₹ per Unit)' : 'Generator Cost Ex-bus (₹ per Unit)'}<br /><small style={{ fontSize: '12px' }}>(Calculated)</small></th> */}
                                              <th>Quantity (MW)</th>
                                              <th>Status</th>
                                              <th>View</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {placedBidsList?.map(
                                              (item, index) => (
                                                <tr key={item?.id}>
                                                  <td>{index + 1}</td>
                                                  <td
                                                    className={
                                                      (role === "GENERATOR" &&
                                                        item?.generatorStatus !==
                                                          "ACCEPTED" &&
                                                        "company-name-blur") ||
                                                      (role === "CONSUMER" &&
                                                        item?.consumerStatus !==
                                                          "ACCEPTED" &&
                                                        "company-name-blur")
                                                    }
                                                  >
                                                    {
                                                      <span>
                                                        {item?.companyName}
                                                      </span>
                                                    }
                                                  </td>
                                                  <td>
                                                    {item?.amount?.toFixed(2)}
                                                  </td>
                                                  {/* <td>{role === 'GENERATOR' ? item?.calculatedLandedCost?.toFixed(2) : item?.calculatedGeneratorCost?.toFixed(2)}</td> */}
                                                  <td>{item?.quantity}</td>
                                                  <td>
                                                    {role === "GENERATOR"
                                                      ? item?.generatorStatus
                                                        ? item?.generatorStatus ===
                                                          "REJECTED"
                                                          ? "DECLINED"
                                                          : item?.generatorStatus
                                                        : "NA"
                                                      : item?.consumerStatus
                                                      ? item?.consumerStatus ===
                                                        "REJECTED"
                                                        ? "DECLINED"
                                                        : item?.consumerStatus
                                                      : "NA"}
                                                  </td>
                                                  <td>
                                                    <div className="align-files-icons-btn">
                                                      <button
                                                        className="btn outline-0"
                                                        onClick={() =>
                                                          handleViewConnection(
                                                            data,
                                                            item
                                                          )
                                                        }
                                                      >
                                                        <img
                                                          src="images/view-icon.png"
                                                          alt="View"
                                                        />
                                                      </button>{" "}
                                                      {item.textState}
                                                    </div>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      ) : (
                                        <h4 className="text-center">
                                          No Connections Placed with the
                                          Selected Capacity
                                        </h4>
                                      )}
                                    </div>
                                  </Tab.Pane>
                                  <Tab.Pane eventKey="second">
                                    <div className=" table-responsive doc-cus-table">
                                      {receivedBidsList &&
                                      receivedBidsList?.length > 0 ? (
                                        <table className="cus-table table-bordered my-documents-table">
                                          <thead className="table-header">
                                            <tr>
                                              <th>S. No.</th>
                                              <th>Company Name</th>
                                              <th>
                                                {"Energy Rate (₹ per Unit)"}
                                              </th>
                                              {/* <th>{'Energy Rate (₹ per Unit)'}<br /><small style={{ fontSize: '12px' }}>(Calculated)</small></th> */}
                                              <th>Quantity (MW)</th>
                                              <th>Status</th>
                                              <th>View</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {receivedBidsList?.map(
                                              (item, index) => (
                                                <tr key={item?.id}>
                                                  <td>{index + 1}</td>
                                                  <td
                                                    className={
                                                      (role === "GENERATOR" &&
                                                        item?.generatorStatus !==
                                                          "ACCEPTED" &&
                                                        "company-name-blur") ||
                                                      (role === "CONSUMER" &&
                                                        item?.consumerStatus !==
                                                          "ACCEPTED" &&
                                                        "company-name-blur")
                                                    }
                                                  >
                                                    {
                                                      <span>
                                                        {item?.companyName}
                                                      </span>
                                                    }
                                                  </td>
                                                  <td>
                                                    {item?.amount?.toFixed(2)}
                                                  </td>
                                                  {/* <td>{role === 'CONSUMER' ? item?.calculatedLandedCost?.toFixed(2) : item?.calculatedGeneratorCost?.toFixed(2)}</td> */}
                                                  <td>{item?.quantity}</td>
                                                  <td>
                                                    {role === "GENERATOR"
                                                      ? item?.generatorStatus
                                                        ? item?.generatorStatus ===
                                                          "REJECTED"
                                                          ? "DECLINED"
                                                          : item?.consumerStatus ===
                                                            "CLOSED"
                                                          ? "CLOSED"
                                                          : item?.generatorStatus
                                                        : "NA"
                                                      : item?.consumerStatus
                                                      ? item?.consumerStatus ===
                                                        "REJECTED"
                                                        ? "DECLINED"
                                                        : item?.generatorStatus ===
                                                          "CLOSED"
                                                        ? "CLOSED"
                                                        : item?.consumerStatus
                                                      : "NA"}
                                                  </td>
                                                  <td>
                                                    <div className="align-files-icons-btn">
                                                      <button
                                                        className="btn outline-0"
                                                        onClick={() =>
                                                          handleApproveBids(
                                                            data,
                                                            item
                                                          )
                                                        }
                                                      >
                                                        <img
                                                          src="images/view-icon.png"
                                                          alt="View"
                                                        />
                                                      </button>{" "}
                                                      {item.textState}
                                                    </div>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      ) : (
                                        <h4 className="text-center">
                                          No Connections Received against the
                                          Selected Capacity
                                        </h4>
                                      )}
                                    </div>
                                  </Tab.Pane>
                                </Tab.Content>
                              </Col>
                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))
                    ) : (
                      <NodataFound />
                    )}
                  </Accordion>
                )}
              </Tab.Container>
            </Tab>
            <Tab
              eventKey={"Withdrawn"}
              title="Withdrawn"
              className="table-scrollY"
            >
              {withdrawnList?.length > 0 ? (
                withdrawnList?.map((item, i) => (
                  <div key={i} className="mb-4 cus-border">
                    <div className="bids-name-wrap bids-name-wrap-header">
                      <CapacityListingHeader item={item} />
                    </div>
                  </div>
                ))
              ) : (
                <NodataFound />
              )}
            </Tab>
            <Tab eventKey={"Expired"} title="Expired" className="table-scrollY">
              {openList?.length > 0 ? (
                openList?.map((item, i) => (
                  <div key={i} className="mb-4 cus-border">
                    <div className="bids-name-wrap bids-name-wrap-header">
                      <CapacityListingHeader item={item} />
                    </div>
                  </div>
                ))
              ) : (
                <NodataFound />
              )}
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default CapacityListingNew;
